import React from "react";
import { dialog, Button, Progress, InfiniteScroll } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Search from "../../../../components/Search";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import ListOfEmployeePresenter from "./ListOfEmployeePresenter";

class LogsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ListOfEmployeePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "commendation_logs";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div>
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">{schema.label}</h4>
                </div>
              </CardView>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "selectedFiles"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(LogsPage);
